import React from "react";
import PinDetailMini from "../components/pin-detail-mini";


function GuideStarwars() {
    return (
        <div className="detail-box">

<h3 align="center">Star Wars</h3>

<div className="videotitle">Star Wars The Empire Strikes Back - 5/4/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="504"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 9/21/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="539"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="540"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="541"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="542"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="543"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="L34"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Clone Wars - 9/9/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="517"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="518"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="519"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="520"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 9/21/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="505"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="506"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="507"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="508"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="509"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="510"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="X60"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 10/26/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="511"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="576"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="578"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="579"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="580"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 10/27/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="599"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="600"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 12/11/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="577"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Clone Wars - 12/13/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="521"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 12/21/20</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="735"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="736"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="738"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Clone Wars - 2/17/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="570"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="571"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="572"/><div className="pinname">(12/29/20 Release Date)</div></li>
<li className="gallerybox"><PinDetailMini pinNumber="573"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="574"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="575"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Bad Batch - 5/4/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="766"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="767"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="768"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="769"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="770"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="771"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars A New Hope - 6/9/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="500"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 6/23/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="734"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="737"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars A New Hope - 11/3/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="699"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="700"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="701"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="702"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="703"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars A New Hope - 10/27/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="795"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="796"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars A New Hope - 11/3/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="749"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="750"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="751"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="752"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="753"/></li>
</ul>
<br/>

<div className="videotitle">SDCC 2021 - 11/26/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="783"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="784"/></li>
</ul>
<br/>

<div className="videotitle">ECCC 2021 - 12/2/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="832"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="833"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 12/22/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="845"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 12/14/21</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="843"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="844"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 1/26/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="825"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="826"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="827"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="829"/></li>
</ul>
<br/>

<div className="videotitle">Disney - 2/8/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="644"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="645"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Book of Boba Fett - 2/8/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="859"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="860"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="861"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="907"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Empire Strikes Back - 4/27/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="U1"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Day - 5/4/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="501"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="L41"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Celebration 2022 - 5/26/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="733"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="995"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="792"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="793"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="794"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="930"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="927"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="828"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="906"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="889"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="999"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="L50"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Obi-Wan Kenobi - 6/29/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1049"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1050"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Force Awakens - 7/20/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="887"/></li>
</ul>
<br/>

<div className="videotitle">SDCC 2022 - 7/20/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="926"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="929"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="L47"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Force Awakens - 8/18/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="888"/></li>
</ul>
<br/>

<div className="videotitle">D23 Expo 2022 - 9/9/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="502"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Clone Wars - 9/28/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="993"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="994"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="996"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="997"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="998"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Book of Boba Fett - 12/21/22</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1121"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1122"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Empire Strikes Back - 1/20/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="503"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Clone Wars - 2/8/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1233"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1234"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1235"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1236"/><div className="pinname">(3/3/23 Release Date)</div></li>
</ul>
<br/>

<div className="videotitle">Disney - 2/14/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1125"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1126"/></li>
</ul>
<br/>

<div className="videotitle">Disney - 3/13/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1024"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1025"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 3/23/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1316"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1317"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1319"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Celebration 2023 - 4/6/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1165"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="931"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="928"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1124"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1239"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1334"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1278"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1279"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1123"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1237"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="L88"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Day - 5/4/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1320"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1321"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1238"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1322"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1318"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars The Mandalorian - 6/19/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="M83"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Return of the Jedi - 6/22/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1276"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1277"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Rebels - 6/27/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1328"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1329"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1331"/><div className="pinname">(9/3/23 Release Date)</div></li>
<li className="gallerybox"><PinDetailMini pinNumber="1333"/><div className="pinname">(11/8/23 Release Date)</div></li>
</ul>
<br/>

<div className="videotitle">SDCC 2023 - 7/19/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1281"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1330"/></li>
</ul>
<br/>

<div className="videotitle">Alliance Fest SDCC 2023 - 7/20/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1367"/></li>
</ul>
<br/>

<div className="videotitle">Disney - 8/22/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1115"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1116"/></li>
</ul>
<br/>

<div className="videotitle">Star Wars Ahsoka - 8/22/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1470"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1471"/><div className="pinname">(Release Date Unknown)</div></li>
<li className="gallerybox"><PinDetailMini pinNumber="1472"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1473"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1474"/><div className="pinname">(9/7/23 Release Date)</div></li>
</ul>
<br/>

<div className="videotitle">NYCC 2023 - 10/12/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1475"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1567"/></li>
<li className="gallerybox"><PinDetailMini pinNumber="1280"/></li>
</ul>
<br/>

<div className="videotitle">Alliance Fest NYCC 2023 - 10/12/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1365"/></li>
</ul>
<br/>

<div className="videotitle">LACC 2023 - 12/1/23</div>
<ul className="gallery mw-gallery-traditional">
<li className="gallerybox"><PinDetailMini pinNumber="1332"/></li>
</ul>
<br/>

        </div>
    );
}

export default GuideStarwars;


